export default __webpack_public_path__ + "static/media/circle.1e1a0d46.webp";